/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wellKnownParsers = void 0;

var _typeParsers = _interopRequireDefault(require("./type-parsers"));

var _objectParser = _interopRequireDefault(require("./object-parser"));

var _wrappers_pb = _interopRequireDefault(require("google-protobuf/google/protobuf/wrappers_pb"));

var _struct_pb = _interopRequireDefault(require("google-protobuf/google/protobuf/struct_pb"));

var _empty_pb = require("google-protobuf/google/protobuf/empty_pb");

var _timestamp_pb = require("google-protobuf/google/protobuf/timestamp_pb");

var _duration_pb = require("google-protobuf/google/protobuf/duration_pb");

var _field_mask_pb = require("google-protobuf/google/protobuf/field_mask_pb");

var _any_pb = require("google-protobuf/google/protobuf/any_pb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The parsers for standard Protobuf types.
 *
 * <p>For the details about how the parsers should work,
 * see {@link https://developers.google.com/protocol-buffers/docs/proto3#json Protobuf documentation}.
 */
var BoolValueParser = /*#__PURE__*/function (_ObjectParser) {
  _inherits(BoolValueParser, _ObjectParser);

  var _super = _createSuper(BoolValueParser);

  function BoolValueParser() {
    _classCallCheck(this, BoolValueParser);

    return _super.apply(this, arguments);
  }

  _createClass(BoolValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var boolValue = new _wrappers_pb["default"].BoolValue();
      boolValue.setValue(object);
      return boolValue;
    }
  }]);

  return BoolValueParser;
}(_objectParser["default"]);

var BytesValueParser = /*#__PURE__*/function (_ObjectParser2) {
  _inherits(BytesValueParser, _ObjectParser2);

  var _super2 = _createSuper(BytesValueParser);

  function BytesValueParser() {
    _classCallCheck(this, BytesValueParser);

    return _super2.apply(this, arguments);
  }

  _createClass(BytesValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var bytesValue = new _wrappers_pb["default"].BytesValue();
      bytesValue.setValue(object);
      return bytesValue;
    }
  }]);

  return BytesValueParser;
}(_objectParser["default"]);

var DoubleValueParser = /*#__PURE__*/function (_ObjectParser3) {
  _inherits(DoubleValueParser, _ObjectParser3);

  var _super3 = _createSuper(DoubleValueParser);

  function DoubleValueParser() {
    _classCallCheck(this, DoubleValueParser);

    return _super3.apply(this, arguments);
  }

  _createClass(DoubleValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var doubleValue = new _wrappers_pb["default"].DoubleValue();
      doubleValue.setValue(object);
      return doubleValue;
    }
  }]);

  return DoubleValueParser;
}(_objectParser["default"]);

var FloatValueParser = /*#__PURE__*/function (_ObjectParser4) {
  _inherits(FloatValueParser, _ObjectParser4);

  var _super4 = _createSuper(FloatValueParser);

  function FloatValueParser() {
    _classCallCheck(this, FloatValueParser);

    return _super4.apply(this, arguments);
  }

  _createClass(FloatValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var floatValue = new _wrappers_pb["default"].FloatValue();
      floatValue.setValue(object);
      return floatValue;
    }
  }]);

  return FloatValueParser;
}(_objectParser["default"]);

var Int32ValueParser = /*#__PURE__*/function (_ObjectParser5) {
  _inherits(Int32ValueParser, _ObjectParser5);

  var _super5 = _createSuper(Int32ValueParser);

  function Int32ValueParser() {
    _classCallCheck(this, Int32ValueParser);

    return _super5.apply(this, arguments);
  }

  _createClass(Int32ValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var int32Value = new _wrappers_pb["default"].Int32Value();
      int32Value.setValue(object);
      return int32Value;
    }
  }]);

  return Int32ValueParser;
}(_objectParser["default"]);

var Int64ValueParser = /*#__PURE__*/function (_ObjectParser6) {
  _inherits(Int64ValueParser, _ObjectParser6);

  var _super6 = _createSuper(Int64ValueParser);

  function Int64ValueParser() {
    _classCallCheck(this, Int64ValueParser);

    return _super6.apply(this, arguments);
  }

  _createClass(Int64ValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var int64Value = new _wrappers_pb["default"].Int64Value();
      int64Value.setValue(object);
      return int64Value;
    }
  }]);

  return Int64ValueParser;
}(_objectParser["default"]);

var StringValueParser = /*#__PURE__*/function (_ObjectParser7) {
  _inherits(StringValueParser, _ObjectParser7);

  var _super7 = _createSuper(StringValueParser);

  function StringValueParser() {
    _classCallCheck(this, StringValueParser);

    return _super7.apply(this, arguments);
  }

  _createClass(StringValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var stringValue = new _wrappers_pb["default"].StringValue();
      stringValue.setValue(object);
      return stringValue;
    }
  }]);

  return StringValueParser;
}(_objectParser["default"]);

var UInt32ValueParser = /*#__PURE__*/function (_ObjectParser8) {
  _inherits(UInt32ValueParser, _ObjectParser8);

  var _super8 = _createSuper(UInt32ValueParser);

  function UInt32ValueParser() {
    _classCallCheck(this, UInt32ValueParser);

    return _super8.apply(this, arguments);
  }

  _createClass(UInt32ValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var uInt32Value = new _wrappers_pb["default"].UInt32Value();
      uInt32Value.setValue(object);
      return uInt32Value;
    }
  }]);

  return UInt32ValueParser;
}(_objectParser["default"]);

var UInt64ValueParser = /*#__PURE__*/function (_ObjectParser9) {
  _inherits(UInt64ValueParser, _ObjectParser9);

  var _super9 = _createSuper(UInt64ValueParser);

  function UInt64ValueParser() {
    _classCallCheck(this, UInt64ValueParser);

    return _super9.apply(this, arguments);
  }

  _createClass(UInt64ValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var uInt64Value = new _wrappers_pb["default"].UInt64Value();
      uInt64Value.setValue(object);
      return uInt64Value;
    }
  }]);

  return UInt64ValueParser;
}(_objectParser["default"]);

var ListValueParser = /*#__PURE__*/function (_ObjectParser10) {
  _inherits(ListValueParser, _ObjectParser10);

  var _super10 = _createSuper(ListValueParser);

  function ListValueParser() {
    _classCallCheck(this, ListValueParser);

    return _super10.apply(this, arguments);
  }

  _createClass(ListValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var listValue = new _struct_pb["default"].ListValue();
      object.forEach(function callback(currentValue, index, array) {
        var valueParser = new ValueParser();
        array[index] = valueParser.fromObject(currentValue);
      });
      listValue.setValuesList(object);
      return listValue;
    }
  }]);

  return ListValueParser;
}(_objectParser["default"]);

var StructParser = /*#__PURE__*/function (_ObjectParser11) {
  _inherits(StructParser, _ObjectParser11);

  var _super11 = _createSuper(StructParser);

  function StructParser() {
    _classCallCheck(this, StructParser);

    return _super11.apply(this, arguments);
  }

  _createClass(StructParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var result = new _struct_pb["default"].Struct();
      var values = new ValueParser();

      for (var fieldName in object) {
        result.getFieldsMap().set(fieldName, values.fromObject(object[fieldName]));
      }

      return result;
    }
  }]);

  return StructParser;
}(_objectParser["default"]);

var ValueParser = /*#__PURE__*/function (_ObjectParser12) {
  _inherits(ValueParser, _ObjectParser12);

  var _super12 = _createSuper(ValueParser);

  function ValueParser() {
    _classCallCheck(this, ValueParser);

    return _super12.apply(this, arguments);
  }

  _createClass(ValueParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var result = new _struct_pb["default"].Value();

      if (object === null) {
        result.setNullValue(_struct_pb["default"].NullValue.NULL_VALUE);
      } else if (typeof object === "number") {
        result.setNumberValue(object);
      } else if (typeof object === "string") {
        result.setStringValue(object);
      } else if (typeof object === "boolean") {
        result.setBoolValue(object);
      } else if (Array.isArray(object)) {
        var parser = new ListValueParser(object);
        var listValue = parser.fromObject(object);
        result.setListValue(listValue);
      } else {
        var _parser = new StructParser(object);

        var structValue = _parser.fromObject(object);

        result.setStructValue(structValue);
      }

      return result;
    }
  }]);

  return ValueParser;
}(_objectParser["default"]);

var EmptyParser = /*#__PURE__*/function (_ObjectParser13) {
  _inherits(EmptyParser, _ObjectParser13);

  var _super13 = _createSuper(EmptyParser);

  function EmptyParser() {
    _classCallCheck(this, EmptyParser);

    return _super13.apply(this, arguments);
  }

  _createClass(EmptyParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var emptyValue = new _empty_pb.Empty();
      return emptyValue;
    }
  }]);

  return EmptyParser;
}(_objectParser["default"]);

var TimestampParser = /*#__PURE__*/function (_ObjectParser14) {
  _inherits(TimestampParser, _ObjectParser14);

  var _super14 = _createSuper(TimestampParser);

  function TimestampParser() {
    _classCallCheck(this, TimestampParser);

    return _super14.apply(this, arguments);
  }

  _createClass(TimestampParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var date = new Date(object);
      var result = new _timestamp_pb.Timestamp();
      result.fromDate(date);
      return result;
    }
  }]);

  return TimestampParser;
}(_objectParser["default"]);

var DurationParser = /*#__PURE__*/function (_ObjectParser15) {
  _inherits(DurationParser, _ObjectParser15);

  var _super15 = _createSuper(DurationParser);

  function DurationParser() {
    _classCallCheck(this, DurationParser);

    return _super15.apply(this, arguments);
  }

  _createClass(DurationParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      object = object.substring(0, object.length - 1);
      var values = object.split(".");
      var result = new _duration_pb.Duration();

      if (values.length === 1) {
        result.setSeconds(values[0]);
      } else if (values.length === 2) {
        result.setSeconds(values[0]);
        var nanos = values[1];

        for (var i = 0; i < 9 - nanos.length; i++) {
          nanos += "0";
        }

        var nanosNumber = parseInt(nanos, 10);
        result.setNanos(nanosNumber);
      }

      return result;
    }
  }]);

  return DurationParser;
}(_objectParser["default"]);

var FieldMaskParser = /*#__PURE__*/function (_ObjectParser16) {
  _inherits(FieldMaskParser, _ObjectParser16);

  var _super16 = _createSuper(FieldMaskParser);

  function FieldMaskParser() {
    _classCallCheck(this, FieldMaskParser);

    return _super16.apply(this, arguments);
  }

  _createClass(FieldMaskParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var fieldMask = new _field_mask_pb.FieldMask();
      fieldMask.setPathsList(object.split(","));
      return fieldMask;
    }
  }]);

  return FieldMaskParser;
}(_objectParser["default"]);

var AnyParser = /*#__PURE__*/function (_ObjectParser17) {
  _inherits(AnyParser, _ObjectParser17);

  var _super17 = _createSuper(AnyParser);

  function AnyParser() {
    _classCallCheck(this, AnyParser);

    return _super17.apply(this, arguments);
  }

  _createClass(AnyParser, [{
    key: "fromObject",
    value: function fromObject(object) {
      var typeUrl = object["@type"];
      var isWellKnown = wellKnownParsers.has(typeUrl);
      var packedValue = isWellKnown ? object["value"] : object;

      var parser = _typeParsers["default"].parserFor(typeUrl);

      var messageValue = parser.fromObject(packedValue);
      var bytes = messageValue.serializeBinary();
      var anyMsg = new _any_pb.Any();
      anyMsg.setTypeUrl(typeUrl);
      anyMsg.setValue(bytes);
      return anyMsg;
    }
  }]);

  return AnyParser;
}(_objectParser["default"]);
/**
 * The map of parsers for standard Protobuf types.
 *
 * @type {Map<string, ObjectParser>}
 */


var wellKnownParsers = new Map([['type.googleapis.com/google.protobuf.BoolValue', new BoolValueParser()], ['type.googleapis.com/google.protobuf.BytesValue', new BytesValueParser()], ['type.googleapis.com/google.protobuf.DoubleValue', new DoubleValueParser()], ['type.googleapis.com/google.protobuf.FloatValue', new FloatValueParser()], ['type.googleapis.com/google.protobuf.StringValue', new StringValueParser()], ['type.googleapis.com/google.protobuf.Int32Value', new Int32ValueParser()], ['type.googleapis.com/google.protobuf.Int64Value', new Int64ValueParser()], ['type.googleapis.com/google.protobuf.UInt32Value', new UInt32ValueParser()], ['type.googleapis.com/google.protobuf.UInt64Value', new UInt64ValueParser()], ['type.googleapis.com/google.protobuf.Struct', new StructParser()], ['type.googleapis.com/google.protobuf.Value', new ValueParser()], ['type.googleapis.com/google.protobuf.ListValue', new ListValueParser()], ['type.googleapis.com/google.protobuf.Empty', new EmptyParser()], ['type.googleapis.com/google.protobuf.Timestamp', new TimestampParser()], ['type.googleapis.com/google.protobuf.Duration', new DurationParser()], ['type.googleapis.com/google.protobuf.FieldMask', new FieldMaskParser()], ['type.googleapis.com/google.protobuf.Any', new AnyParser()]]);
exports.wellKnownParsers = wellKnownParsers;
//# sourceMappingURL=well-known-parsers.js.map